module.exports = __webpack_public_path__ + "static/media/graph-report.81a1608f.png";